<template>
  <TimePicker
    v-model="time"
    :open="open"
    hideDisabledOptions
    inputReadOnly
    :class="{
      thumbnailTimePicker: !$vuetify.theme.dark,
      darkThumbnailTimePicker: $vuetify.theme.dark,
    }"
    :format="format"
    :disabledSeconds="getTime.bind(this, { value: videoSeconds })"
    :disabledMinutes="getTime.bind(this, { value: videoMinutes, key: 'mm' })"
    :disabledHours="getTime.bind(this, { value: videoHours, key: 'hh' })"
    :valueFormat="format"
    :allowClear="false"
    :disabled="disabled"
    @openChange="handleOpen"
    @change="handleEmitTime"
  />
</template>

<script>
import { TimePicker } from 'ant-design-vue'
import 'ant-design-vue/lib/time-picker/style/index.css'

export default {
  name: 'AntTimePicker',
  components: {
    TimePicker,
  },
  watch: {
    currentVal(val) {
      if (val) this.time = val
    },
  },
  props: {
    timeVideo: {
      default: 0,
      type: Number,
    },
    currentVal: {
      type: String,
      required: false,
    },
    startVal: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    thresholdTime: {
      type: String,
      default: '',
      required: false,
    },
  },
  data: () => ({
    open: false,
    time: '00:00',
    videoHours: 0,
    videoMinutes: 0,
    videoSeconds: 0,
    lastTime: '',
  }),
  mounted() {
    this.formatVideoLength()
    this.lastTime = this.startVal
    this.time = this.startVal
  },
  computed: {
    format() {
      if (this.timeVideo >= 3600) {
        return 'HH:mm:ss'
      }
      return 'mm:ss'
    },
    thresholdTimeSplitted() {
      return this.getSplittedTime(this.thresholdTime)
    },
    timeFirstValue() {
      return this.time.split(':')[0]
    },
  },
  methods: {
    getSplittedTime(item) {
      const [part0, part1, part2] = item.split(':').reverse()
      return [part2, part1, part0]
    },
    formatVideoLength() {
      let videoLength = this.timeVideo

      this.timeVideo = videoLength
      this.videoHours = Math.floor(this.timeVideo / 3600)
      this.videoMinutes =
        this.formatTimeToSeconds(this.time) / 3600 < this.videoHours
          ? 59
          : Math.floor((this.timeVideo % 3600) / 60)

      this.videoSeconds = videoLength % 60
    },
    formatTimeToSeconds(time) {
      if (!time) return 0
      return time.split(':').reduce((acc, time) => 60 * acc + +time)
    },
    getTime({ value, key = 'ss' }) {
      let arr

      if (key === 'ss' && Number(this.timeFirstValue) != this.videoMinutes) {
        arr = []
      } else {
        arr = Array.from({ length: 61 - value }, (_, i) => i + value + 1)
      }

      const thresholdIndex = { hh: 0, mm: 1, ss: 2 }
      let threshold = this.thresholdTimeSplitted[thresholdIndex[key]]
      const time = this.getSplittedTime(this.time)

      if (key === 'ss') {
        if (
          time[thresholdIndex['mm']] !=
          this.thresholdTimeSplitted[thresholdIndex['mm']]
        )
          return arr
        if (
          time[thresholdIndex['hh']] !=
          this.thresholdTimeSplitted[thresholdIndex['hh']]
        )
          return arr
      }
      if (key === 'mm') {
        if (
          time[thresholdIndex['hh']] !=
          this.thresholdTimeSplitted[thresholdIndex['hh']]
        )
          return arr
      }

      if (threshold) {
        threshold = parseInt(threshold, 10)

        for (let i = 0; i < threshold; i++) {
          arr.push(i)
        }
      }

      return arr
    },
    handleEmitTime() {
      this.formatVideoLength()

      const [timeArr] = this.time.split(':')
      const [lastVal] = this.lastTime.split(':')

      if (lastVal === timeArr) this.open = false

      this.$emit('changedTime', this.time)
      this.lastTime = this.time
    },
    handleOpen() {
      this.$emit('handleOpen')
      this.open = !this.open
    },
  },
}
</script>

<style lang="scss">
.ant-time-picker-input {
  height: 40px;
  font-size: 12px;
  padding: 0 8px;
  background: varFigma(neutral-100-white);
  color: varFigma(neutral-40-light);
  border-color: varFigma(neutral-95-lightest);
}
.ant-time-picker-input:not([disabled]) {
  color: varFigma(neutral-40-light);
}
.ant-time-picker-input:hover:not([disabled]) {
  border-color: rgba(0, 0, 0, 0.87);
}

.ant-time-picker-panel-input-wrap {
  display: none;
}
.ant-time-picker-panel-combobox {
  margin-top: 40px;
}
.ant-time-picker-panel-select ul {
  padding-bottom: 0px;
}
</style>
